import { gql } from '@apollo/client'

export const AddTopicDocument = gql`
  mutation addTopicToDocument($input: AddTopicDocumentInput!) {
    addTopicDocument(input: $input) {
      document {
        id
      }
    }
  }
`

export const RemoveTopicDocument = gql`
  mutation removeTopicToDocument($input: RemoveTopicDocumentInput!) {
    removeTopicDocument(input: $input) {
      document {
        id
      }
    }
  }
`
